import { call, put } from 'redux-saga/effects';
import { Api } from 'old-store/utils';
import ApiErrors from 'old-store/utils/API/APIErrors';
import { SagaIterator } from 'redux-saga';
import { fetchTemplatesFontsSuccess } from 'old-store/actions';

export const fetchTemplateFontsSaga = function* (): SagaIterator {
  try {
    const response = yield call(Api.Templates.getTempalteFonts);
    ApiErrors.checkOnApiError(response);

    yield put(fetchTemplatesFontsSuccess(response?.result?.fonts));
  } catch (e) {
    console.log(e);
  }
};
